/** Deterministic friendly name for a pubkey, e.g. "Amber Cheetah". */

const ADJECTIVES = [
  "Amber", "Brave", "Bright", "Calm", "Clever", "Crimson", "Daring", "Golden",
  "Gentle", "Happy", "Ivory", "Jolly", "Keen", "Lively", "Lucky", "Mighty",
  "Noble", "Proud", "Quick", "Radiant", "Silent", "Swift", "Vivid", "Warm",
];

const ANIMALS = [
  "Cheetah", "Crane", "Elephant", "Falcon", "Gazelle", "Giraffe", "Hare",
  "Heron", "Hippo", "Impala", "Jackal", "Kestrel", "Leopard", "Lion",
  "Mamba", "Oryx", "Ostrich", "Pangolin", "Rhino", "Serval", "Sunbird",
  "Vervet", "Warthog", "Zebra",
];

export function genUserName(pubkey: string): string {
  let h = 0;
  for (let i = 0; i < pubkey.length; i++) {
    h = (h * 31 + pubkey.charCodeAt(i)) >>> 0;
  }
  const a = ADJECTIVES[h % ADJECTIVES.length];
  const n = ANIMALS[Math.floor(h / ADJECTIVES.length) % ANIMALS.length];
  return `${a} ${n}`;
}
